import "../../../sass/components/BuyFlow.scss";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import i18n from "i18next";
import {useEffect, useReducer} from "react";
import Summary from "@/Pages/BuyFlow/Summary";
import ChoosePlan from "@/Pages/BuyFlow/ChoosePlan";
import ChooseAddOns from "@/Pages/BuyFlow/ChooseAddOns";
import Checkout from "@/Pages/BuyFlow/Checkout";
import {getCookie, setCookie, deleteCookies} from "@/Utilities/CookieManager";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import {usePage} from '@inertiajs/inertia-react';

function reducer(state, action) {
    switch(action.type) {
        case "toggleValue":
            return { ...state, toggleValue: action.payload.toggleValue }
        case "billingFrequency":
            return { ...state, billingFrequency: action.payload.billingFrequency }
        case "showFreeModule":
            return { ...state, showFreeModule: action.payload.showFreeModule }
        case "totalPrice":
            return { ...state, totalPrice: action.payload.totalPrice }
        case "initialCart":
            return { ...state, cart: action.payload.initialCart }
        case "toggleCart":
            return { ...state, cart: action.payload.toggleCart }
        case "addToCart":
            return { ...state, cart: [ ...state.cart, action.payload.addToCart ] }
        case "removeFromCart":
            return { ...state, cart: state.cart.filter(item => item !== action.payload.removeFromCart) }
        case "anyTooltipsOpen":
            return { ...state, anyTooltipsOpen: action.payload.anyTooltipsOpen }
        case "initialData":
            return { ...state, payload: action.payload.payload, bundles: action.payload.bundles, customBundles: action.payload.customBundles, addOns: action.payload.addOns }
        case "oneTimePrice":
            return { ...state, oneTimePrice: action.payload.oneTimePrice }
        case "step":
            return { ...state, step: action.payload.step }
        case "cartCookies":
            return { ...state, cartCookies: action.payload.cartCookies }
        case "toggleCookie":
            return { ...state, toggleCookie: action.payload.toggleCookie }
        case "stepCookie":
            return { ...state, stepCookie: action.payload.stepCookie }
        case "showCheckoutModal":
            return { ...state, showCheckoutModal: action.payload.showCheckoutModal }
        case "shownAddOns":
            return { ...state, shownAddOns: action.payload.shownAddOns }
        case "optionalModuleTotalPrice":
            return { ...state, optionalModuleTotalPrice: action.payload.optionalModuleTotalPrice }
        case "env":
            return { ...state, env: action.payload.env }
        case "pbEnv":
            return { ...state, pbEnv: action.payload.pbEnv }
        case "isLoading":
            return { ...state, isLoading: false }
        case "isLoadingSession":
            return { ...state, isLoadingSession: action.payload.isLoadingSession }
        case "direction":
            return { ...state, direction: action.payload.direction }
        default:
            return state;
    }
}

export default function BuyFlow() {

    const [state, dispatch] = useReducer(reducer,
        {
            toggleValue: typeof getCookie('toggle') !== "undefined" ? getCookie('toggle')[0] : "thirtysixmonths",
            billingFrequency: typeof getCookie('billingFrequency') !== "undefined" ? getCookie('billingFrequency')[0] : "monthly",
            showFreeModule: true,
            isLoading: true,
            payload: {},
            bundles: [],
            customBundles: [],
            addOns: [],
            oneTimePrice: 0,
            totalPrice: 0,
            cart: [],
            optionalModuleTotalPrice: 0,
            env: usePage().props.env,
            pbEnv: usePage().props.pbEnv,
            showCheckoutModal: false,
            anyTooltipsOpen: false,
            step: typeof getCookie('step') !== "undefined" ? getCookie('step')[0] : 1,
            cartCookies: getCookie('cartProducts'),
            shownAddOns: [],
            hasCustomSalesForceOffer: usePage().props.auth.current_organization.has_custom_salesforce_offer,
            direction: null,
            stepTracker: [],
            isLoadingSession: false,
        })

    const auth = usePage().props.auth;
    const paymentApiKey = usePage().props.paymentsApiKey;

    document.body.id = "buy-flow-body";

    useEffect(() => {
        axios.get(route('manage.buyflow.payload')).then(res => {
                // @TODO : Need to handle if there's no data; res.data.data doesn't exist, res.data.length === 0
                let bundles = res.data.data ? res.data.data.bundles : [];
                let customBundles =  res.data.data ? res.data.data.customBundles : [];
                let addOns =  res.data.data ? res.data.data.addOns : [];

                dispatch({ type: "initialData", payload: {
                        payload: {},
                        bundles: bundles,
                        customBundles: customBundles,
                        addOns: addOns,
                    }});

                if(typeof getCookie('cartProducts') !== "undefined" && typeof state.cartCookies !== "undefined") {
                    dispatch({ type: "initialCart", payload: {
                            initialCart: []
                        }});
                }

                if(state.cart.length === 0) {
                    dispatch({ type: "step", payload: {step: 1}});
                }

            }).then(() => {

            dispatch({type: "isLoading", payload: {isLoading: false}})
        });
    }, [])

    useEffect(() => {
        if((typeof getCookie('userId') !== "undefined" && getCookie('userId')[0] !== auth.user.uuid) ||
            (typeof getCookie('orgId') !== "undefined" && getCookie('orgId')[0] !== auth.current_organization.uuid)) {
            let cookieConsent = false;
            if(typeof getCookie("cookieConsent") !== "undefined" && getCookie("cookieConsent")[0]) {
                cookieConsent = getCookie("cookieConsent")[0];
            }
            deleteCookies();
            setCookie("cookieConsent", cookieConsent, 365);
        }

        let orgIdCookieValue = auth.current_organization.uuid;
        const orgIdCookie = 'orgId';
        setCookie(orgIdCookie, orgIdCookieValue, 3);

        let userIdCookieValue = auth.user.uuid;
        const userIdCookie = 'userId';
        setCookie(userIdCookie, userIdCookieValue, 3);
    }, [])

    useEffect(() => {
        let newCookieValue = state.step;
        const stepCookie = 'step';
        setCookie(stepCookie, newCookieValue, 3);
    }, [state.step])

    useEffect(() => {
        let newCookieValue = state.billingFrequency;
        const billingCookie = 'billingFrequency';
        setCookie(billingCookie, newCookieValue, 3);
    }, [state.billingFrequency])

    useEffect(() => {
        if(state.toggleValue === "monthly") {
            dispatch({ type: "billingFrequency", payload: { billingFrequency: "monthly" }});
        }

        let optionalModules = state.cart
            .filter(item => item.type === "package")
            .map(item => item.modules)
            .flat(1)
            .filter(item => (item.isIncluded && !item.required));

        let optionalModulePrices;

        if(optionalModules.length > 0) {
            optionalModulePrices = optionalModules.map(item => item.price).reduce((acc, curr) => acc + curr, 0);
        } else {
            optionalModulePrices = 0;
        }

        dispatch({ type: "optionalModuleTotalPrice", payload: { optionalModuleTotalPrice: optionalModulePrices }});

        dispatch({ type: "totalPrice", payload: { totalPrice: state.cart.filter(i => i.type !== "add-on").reduce((acc, curr) => acc + curr.price, state.optionalModuleTotalPrice ? state.optionalModuleTotalPrice : 0) }});

    }, [state.cart, state.toggleValue, state.optionalModuleTotalPrice])

    useEffect(() => {
        let addOnCartItems = state.cart.filter(item => item.type === "add-on");
        let nonAddOnProductIds =
            typeof state.cart.filter(item => item.type !== "add-on") === "undefined" ?
                [] : state.cart.filter(item => item.type !== "add-on").map(item => item.productId);

        if(addOnCartItems.length > 0) {
            for (let item of addOnCartItems) {
                if(!item.productIds.some(r=> nonAddOnProductIds.includes(r))) {
                    dispatch({ type: "removeFromCart", payload: { removeFromCart: item }})
                }
            }
        }

        dispatch({ type: "oneTimePrice", payload: { oneTimePrice: state.cart.filter(item => item.type === "add-on").reduce((acc, curr) => acc + curr.price, 0 ) }});

        let newCartCookie = [];
        const cartCookie = "cartProducts";

        state.cart.map(item => {
            if(item.type === "package") {
                let toggledBundleItem = state.bundles.filter(bundle => bundle.name === item.name)
                    .filter(item => item.term === state.toggleValue)[0];
                newCartCookie.push(toggledBundleItem.productId);
            } else if(item.type === "module") {
                let toggledCustomBundleItem = state.customBundles.filter(bundle => bundle.name === item.name)
                    .filter(item => item.term === state.toggleValue)[0];
                newCartCookie.push(toggledCustomBundleItem.productId);
            } else if(item.type === "add-on") {
                let toggledAddOnItem = state.addOns.filter(addOn => addOn.name === item.name)[0];
                newCartCookie.push(toggledAddOnItem.productId);
            }
        });

        setCookie(cartCookie, newCartCookie, 3);
        dispatch({ type: "cartCookies", payload: { cartCookies: state.cart.map(item => item.productId) }});

        let shownAddOns = [];
        state.addOns.map((addOn) => {
            for (let item of state.cart) {
                if(addOn.productIds.includes(item.productId) && addOn.productType.toLowerCase() !== 'usage') {
                    shownAddOns.push(addOn);
                }
            }
            dispatch({ type: "shownAddOns", payload: { shownAddOns: shownAddOns }});
        });

        if(state.cart.length === 0 && state.step > 1) {
            dispatch({ type: "step", payload: {step: 1}});
        }

    }, [state.cart]);

    useEffect(() => {
        let newCookieValue = state.toggleValue;
        const toggleCookie = 'toggle';
        setCookie(toggleCookie, newCookieValue, 3);

        let toggleCart = [];

        toggleCart = state.cart.map(item => {
            if(item.type === "package") {
                return state.bundles.filter(bundle => bundle.name === item.name)
                    .filter(item => item.term === state.toggleValue)[0];
            } else if(item.type === "module") {
                return state.customBundles.filter(bundle => bundle.name === item.name)
                    .filter(item => item.term === state.toggleValue)[0];
            } else if(item.type === "add-on") {
                return state.addOns.filter(addOn => addOn.name === item.name)[0];
            }
        });

        dispatch({ type: "toggleCart", payload: { toggleCart: toggleCart }});
    }, [state.toggleValue])

    useEffect(() => {
        if (state.direction === 'forward') {
            moveForwardStep()
        }
        if (state.direction === 'backward') {
            moveBackwardStep()
        }
        state.direction = null;
    }, [state.direction])


    function moveForwardStep() {
        state.stepTracker.push(state.step);
        if (state.shownAddOns.length === 0) {
            dispatch({ type: "step", payload: { step: 3 }});
        } else {
            dispatch({ type: "step", payload: { step: state.step + 1 }});
        }
    }

    function moveBackwardStep() {
        const backstep  = state.stepTracker.pop();
        if (!backstep) {
            history.back();
        } else {
            dispatch({ type: "step", payload: {step: backstep}});
        }
    }

    const renderCurrentStep = () => {
        if (state.hasCustomSalesForceOffer) {
            return <Checkout state={state} dispatch={dispatch} apiKey={paymentApiKey} />;
        } else {
            switch (state.step) {
                case 1:
                    return <ChoosePlan state={state} dispatch={dispatch} />;
                case 2:
                    return <ChooseAddOns state={state} dispatch={dispatch} />;
                case 3:
                    return <Checkout state={state} dispatch={dispatch} apiKey={paymentApiKey} />;
                default:
                    return null;
            }
        }
    };

    const renderSummary = () => {
        if ((state.step === 1 || state.step === 2) && !state.hasCustomSalesForceOffer) {
            return <Summary state={state} dispatch={dispatch} />;
        }
        return null; // Default case
    };

    return (
        <div>
            {!state.isLoading && <div className="buy-flow">
                {state.showCheckoutModal ? <GeneralPurchaseModal state={state} dispatch={dispatch}/> : null }
                {state.anyTooltipsOpen && <div className="fade modal-backdrop slider-backdrop show" />}
                <div className="buy-flow-plans">
                    <ButtonBorderless dataQa="back-button" disabled={state.isLoadingSession}
                                      onClick={() => dispatch({ type: "direction", payload: {direction: 'backward'}})}>
                        <i className="fas fa-chevron-left"/>
                        {i18n.t('buy-flow.back')}
                    </ButtonBorderless>
                    {renderCurrentStep()}
                </div>
                {renderSummary()}
            </div>}
        </div>
    )
}
